export default "__VITE_ASSET__Frvjf_Z2__"